module.exports = __webpack_public_path__ + "img/09-government-support.1f196c19.png";